var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-bar w-xs p-2 text-left"},[_c('div',{staticClass:"relative text-md flex justify-center w-full p-1 pr-4 rounded-md border",class:{
    'bg-red-10/80 text-red-100 border-red-100': _vm.status=='error',
    'bg-green-10/80 text-green-100 border-green-100': _vm.status=='success',
    'bg-orange-10/80 text-orange-100 border-orange-100': _vm.status=='alert',
  },staticStyle:{"box-shadow":"0 0 .5em rgba(0, 0, 0, 0.3)"}},[_c('div',{staticClass:"font-bold absolute right-0 mr-3 cursor-pointer",on:{"click":function($event){return _vm.$emit('exit')}}},[_vm._v("✖")]),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }